// extracted by mini-css-extract-plugin
export default {"labelDescription":"ThankYouSection_labelDescription__av+O8"};